import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Sidebar from "../components/Sidebar.vue";
import Week from "../views/Week.vue";
import Reserve from "../views/Reserve.vue";
import ReserveDetails from "../views/ReserveDetails.vue";
import CatcherMembers from "../views/CatcherMembers";
import SettingPayment from "../views/SettingPayment";
import Users from "../views/System/Users.vue";
import Roles from "../views/System/Roles.vue";
import Clubs from "../views/System/Clubs.vue";
import AssignmentActivation from "../views/Activations/AssignmentActivation.vue";
import TutoringFollowUp from "../views/Tutorias/TutoringFollowUp.vue";
import CampanasQr from "../views/CobroQr/CampanasQr.vue";
import PromotoresQr from "../views/CobroQr/PromotoresQr.vue";
import VentasQr from "../views/CobroQr/VentasQr.vue";
import MisClientesQr from "../views/CobroQr/MisClientesQr.vue";
import NotFound from "../views/404.vue";
import MassRenewals from "../views/MassRenewals";
import RenewalsFollowUp from "../views/RenewalsFollowUp";

/* Paymentlinks */
import PaymentsLinks from "../views/Payments/PaymentsLinksView.vue";
import PaymentsLinksList from "../views/Payments/PaymentsLinksList.vue";
import PaymentLinkDetail from "../views/Payments/PaymentLinkDetail.vue";

/* Customer portfolio */
import CustomerPortfolioView from "../views/CustomerPortfolio/CustomerPortfolioView.vue";
import CustomerPortfolioViewV2 from "../views/CustomerPortfolio/CustomerPortfolioView_v2.vue";
import Statistics from "../views/Renewals/Statistics.vue";
import DetailsRenewals from "../views/Renewals/DetailsRenewals.vue";

/* Financing Payments */
import FinancingPayments from "../components/Capturador/FinancingPayments.vue";

/**
 * Membership
 */
import MemberProfile from "../views/Membership/MemberProfile";

/**
 * Permissions
 */
import { checkPermission, checkRole } from "@/utils/permissions";

/**
 * Capturador
 */
import NavbarCap from "../components/Capturador/NavbarCap.vue";
import NewMemberCap from "../views/Capturador/NewMemberCap.vue";
import ListMembers from "../views/Capturador/ListMembers.vue";
import ProfileMemberCap from "../views/Capturador/ProfileMemberCap.vue";
import LoginCap from "../views/Capturador/LoginCap.vue";
import PaymentsLinksView from "../views/Payments/PaymentsLinksView.vue";

/* Catalogos */
import DiscountCodes from "@/views/CodigosDescuento/IndexView.vue";

/** Renewals */
import RenewalGlobal from "@/views/Renewals/RenewalGlobal.vue";
import ResortViewClient from "@/views/Membership/ResortViewClient.vue";
import LandingPaymentRenewal from "@/views/Landings/LandingPaymentRenewal.vue";
import LandingPaymentRenewalOnline from "@/views/Landings/LandingPaymentRenewalOnline.vue";
import Reporteria from "@/views/Renewals/Reporteria.vue";
import OnlineRenewal from "@/views/Renewals/OnlineRenewal.vue";
import EstadisticasSocios from "@/views/Membership/EstadisticasSocios.vue";

import PublicMembers from "@/views/PublicMembers/Members.vue";
import MembersCerts from "@/views/Certs/MembersCerts.vue";

import Certificates from "../views/Capturador/CertificatesCap.vue";
import FoliosCap from "../views/Capturador/FoliosCap.vue";

import ProfileMemberRouter from "@/views/Capturador/ProfileMemberRouter.vue";

import ResortsConfig from "@/views/RCI/ResortsConfig.vue";
import PricesConfig from "@/views/RCI/PricesConfig.vue";

import DocumensoEmbed from "@/views/Documenso/DocumensoEmbed.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Sidebar,
    children: [
      {
        path: "/week",
        name: "week",
        component: Week,
        meta: {
          requiresAuth: true,
          permission: "list-weeks",
        },
      },
      // {
      //   path: "/statistics",
      //   name: "statistics",
      //   component: Statistics,
      //   meta: {
      //     requiresAuth: true,
      //     permission: "renewals-statistics",
      //   },
      // },
      {
        path: "/statistics",
        name: "statistics",
        component: Reporteria,
        meta: {
          requiresAuth: true,
          permission: "renewals-statistics",
        },
      },
      {
        path: "/statistics-members",
        name: "StatisticsMembers",
        component: EstadisticasSocios,
        meta: {
          requiresAuth: true,
          permission: "members-statistics",
        },
      },
      {
        path: "/reserve",
        name: "reserve",
        component: Reserve,
        meta: {
          requiresAuth: true,
          permission: "list-bookings",
        },
      },
      {
        path: "/reserve-details",
        name: "ReserveDetails",
        component: ReserveDetails,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/catcher-members",
        name: "catcherMembers",
        component: CatcherMembers,
        meta: {
          requiresAuth: true,
          permission: "list-members",
        },
      },
      {
        path: "/online-renewals",
        name: "onlineRenewals",
        component: OnlineRenewal,
        meta: {
          requiresAuth: true,
          permission: "renewals-online",
        },
      },
      {
        path: "/discount-codes",
        name: "DiscountCodes",
        component: DiscountCodes,
        meta: {
          requiresAuth: true,
          permission: "list-discount-codes",
        },
      },
      {
        path: "/customer-portfolio-old",
        name: "customerPortfolio",
        component: CustomerPortfolioView,
        meta: {
          requiresAuth: true,
          permission: "renewals-customer-portfolio",
        },
      },
      {
        path: "/customer-portfolio",
        name: "customerPortfolio",
        component: CustomerPortfolioViewV2,
        meta: {
          requiresAuth: true,
          permission: "renewals-customer-portfolio",
        },
      },
      {
        path: "/bookings",
        name: "bookings",
        component: require("../views/Bookings/BookingsList.vue").default,
        meta: {
          requiresAuth: true,
          permission: "renewals-customer-portfolio",
        },
      },
      {
        path: "/renewals-follow-up",
        name: "renewalsFollowUp",
        component: RenewalsFollowUp,
        meta: {
          requiresAuth: true,
          permission: "renewals-follow-up",
        },
      },
      {
        path: "/setting-payment",
        name: "SettingPayment",
        component: SettingPayment,
        meta: {
          requiresAuth: true,
          permission: "list-setting-payments",
        },
      },
      {
        path: "/membership-profile",
        name: "membershipProfile",
        component: MemberProfile,
        meta: {
          requiresAuth: true,
          permission: "show-profile-members",
        },
      },
      {
        path: "/details-renewals",
        name: "detailsRenewals",
        component: DetailsRenewals,
        meta: {
          requiresAuth: false,
        },
      },
      // {
      //   path: "/payments-links",
      //   name: "paymentsLinks",
      //   component: PaymentsLinks,
      //   meta: {
      //     requiresAuth: true,
      //     permission: "list-paymentslinks",
      //   },
      // },
      {
        path: "/system-users",
        name: "systemUsers",
        component: Users,
        meta: {
          requiresAuth: true,
          permission: "list-system-users",
        },
      },
      {
        path: "/system-roles",
        name: "systemRoles",
        component: Roles,
        meta: {
          requiresAuth: true,
          permission: "list-system-roles",
        },
      },
      {
        path: "/system-clubs",
        name: "systemClubs",
        component: Clubs,
        meta: {
          requiresAuth: true,
          permission: "list-system-clubs",
        },
      },
      {
        path: "/activations",
        name: "activations",
        component: AssignmentActivation,
        meta: {
          requiresAuth: true,
          permission: "list-members-activations",
        },
      },
      {
        path: "/tutoring-follow-up",
        name: "tutoringFollowUp",
        component: TutoringFollowUp,
        meta: {
          requiresAuth: true,
          permission: "list-tutoring-follow-up",
          roles: ["admin", "ultrauser"],
        },
      },
      /* Cobro por QR de promotores */
      {
        path: "/qr-campanas",
        name: "qrCampanas",
        component: CampanasQr,
        meta: { requiresAuth: true, permission: "qr-campanas" },
      },
      {
        path: "/qr-promotores",
        name: "qrPromotores",
        component: PromotoresQr,
        meta: { requiresAuth: true, permission: "qr-promotores" },
      },
      {
        path: "/qr-ventas",
        name: "qrVentas",
        component: VentasQr,
        meta: { requiresAuth: true, permission: "qr-ventas" },
      },
      {
        path: "/qr-mis-clientes",
        name: "qrMisClientes",
        component: MisClientesQr,
        meta: { requiresAuth: true, permission: "qr-mis-clientes" },
      },
      {
        path: "/404",
        name: "NotFound",
        component: NotFound,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/payments-links",
        name: "paymentsLinks",
        component: PaymentsLinksList,
        meta: {
          requiresAuth: true,
          permission: "list-paymentslinks",
        },
        /* children: [
          {
            path: "list",
            name: "listPayments",
            component: PaymentsLinksList,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: ":id",
            name: "paymentLinkDetail",
            component: PaymentLinkDetail,
            meta: {
              requiresAuth: true,
            },
          },
        ], */
      },
      {
        path: "/payments-links-details",
        name: "paymentsLinksDetails",
        component: PaymentLinkDetail,
        meta: {
          requiresAuth: true,
          permission: "details-paymentslinks",
        },
      },
      {
        path: "/renewals-global",
        name: "renewalsGlobal",
        component: RenewalGlobal,
        meta: {
          requiresAuth: true,
          permission: "renewals-global",
        },
      },
      {
        path: "/public-members",
        name: "publicMembers",
        component: PublicMembers,
        meta: {
          requiresAuth: true,
          permission: "list-public-members",
        },
      },
      {
        path: "/certificates-members",
        name: "membersCerts",
        component: MembersCerts,
        meta: {
          requiresAuth: true,
          permission: "list-certificates-members",
        },
      },
      {
        path: "/rci-config",
        name: "rciConfig",
        component: ResortsConfig,
        meta: {
          requiresAuth: true,
          permission: "rci-config",
        },
      },
      {
        path: "/rci-prices-config",
        name: "PricesConfig",
        component: PricesConfig,
        meta: {
          requiresAuth: true,
          permission: "rci-prices-config",
        },
      },
    ],
  },
  {
    path: "/logincap",
    name: "LoginCap",
    component: LoginCap,
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/navbar-cap",
    name: "navbar-cap",
    component: NavbarCap,
    children: [
      {
        path: "/new-member",
        name: "NewMemberCap",
        component: NewMemberCap,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/list-members",
        name: "ListMembers",
        component: ListMembers,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/financing-payments",
        name: "FinancingPayments",
        component: FinancingPayments,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/profile-member",
        name: "ProfileMemberCap",
        // component: ProfileMemberCap,
        component: ProfileMemberRouter,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/guests",
        name: "Guests",
        component: Certificates,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/folios",
        name: "FoliosCap",
        component: FoliosCap,
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: "/resort-view-client",
    name: "ResortViewClient",
    component: ResortViewClient,
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/lading-payment-renewal",
    name: "LandingPaymentRenewal",
    component: LandingPaymentRenewal,
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/lading-payment-renewal-online",
    name: "LandingPaymentRenewal",
    component: LandingPaymentRenewalOnline,
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/sign/:token",
    name: "DocumensoSign",
    component: DocumensoEmbed,
    meta: {
      isAuth: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Rutas restringidas por rol: el permiso no alcanza para entrar
    if (!checkRole(to.meta.roles)) {
      next("/404");
      return;
    }
    if (checkPermission(to.meta.permission)) {
      next();
      return;
    }
    next("/404");
    return;
  } else {
    next();
    return;
  }

  if (to.matched.some((record) => record.meta.isAuth)) {
    if (localStorage.getItem("user")) {
      next("/week");
      return;
    }
    next();
  } else {
    next();
  }
});

export default router;
